<template> </template>

<script>
import { mapGetters } from 'vuex'

import { NEXT_SECTION } from '@/store/modules/tasting/types'

export default {
  name: 'tasting',
  mounted() {
    if (!this.section) {
      this.$store.dispatch(NEXT_SECTION)
    }
  },
  computed: {
    ...mapGetters({
      tasting: 'currentTasting',
      section: 'currentSection',
      firebaseId: 'tastingFirebaseId'
    })
  }
}
</script>
